module.exports = __webpack_public_path__ + "static/media/solutionIcon.3a7abfbc.svg";